
//Représente les paramètres de recherche des compléments comptable BT-30
export class AeFRechercherComplementsComptableBt30Parametres 
{
  //Création
  constructor () 
  {
    this.identifiantSession = "";
    this.identifiantsFactures = [];
  }

  //Identifiant de la session
  public identifiantSession: string;

  //Identifiants des factures d’achat
  public identifiantsFactures: string[];
}

//Représente le résultat de la recherche des compléments comptable BT-30
export class AeFRechercherComplementsComptableBt30Resultat 
{
  //Indique si l’utilisateur doit faire une sélection manuelle du complément comptable
  public selectionManuelle!: boolean;

  //Numéro de facture
  public numeroFacture!: string;

  //Compléments comptable
  public complementsComptable!: AeFComplementComptableBt30[];
}

//Représente un complément comptable
export class AeFComplementComptableBt30 
{
  //Identifiant
  public identifiant!: string;

  //Nom de l’entreprise
  public nomEntreprise!: string;

  //Siret de l’entreprise
  public siretEntreprise!: string;

  //Siren de l’entreprise
  public sirenEntreprise!: string;

  //Iban
  public iban!: string;

  //Bic
  public bic!: string;

  //Date de mise à jour de l’iban
  public dateMiseAJourIban!: Date | null;

  //Numéro de TVA
  public numeroTva!: string | null;
}
